import { formatCallDateET } from '../services/date'

/**
 * Format handle time from a call record, filtering out invalid XML data.
 * @param {Object} call - Call record object
 * @returns {string} Formatted handle time or empty string
 */
function formatHandleTime (call) {
  const isValidFormatted = call.call_duration_formatted &&
    typeof call.call_duration_formatted === 'string' &&
    !call.call_duration_formatted.includes('xsi:nil') &&
    !call.call_duration_formatted.startsWith('{')

  if (isValidFormatted) {
    return call.call_duration_formatted
  }

  if (call.handle_time && call.handle_time > 0) {
    const hours = Math.floor(call.handle_time / 3600)
    const minutes = Math.floor((call.handle_time % 3600) / 60)
    const seconds = call.handle_time % 60
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }

  return ''
}

/**
 * Transform a call record into the array format expected by the Table component.
 * Table expects: [date, ANI, DNIS, call_id, direction, company, agent, ..., handle_time, ..., call_type, disposition, notes, ..., customer_name, customer_company]
 * @param {Object} call - Call record from the database
 * @returns {Array} Array representation of the call for table display
 */
export function transformCallRow (call) {
  return [
    formatCallDateET(call.call_date, { fallback: '' }),
    call.caller_number || call.ani || '',
    call.dnis || '',
    call.call_id || '',
    call.direction || call.call_type_raw || '',
    call.campaign_name || '',
    call.agent_name || '',
    '',
    '',
    formatHandleTime(call),
    '',
    '',
    '',
    call.disposition || '',
    call.call_notes || '',
    '',
    '',
    call.caller_name || call.customer_name_five9 || '',
    call.caller_company || ''
  ]
}
